import type { CarePlan } from '@lmc/ts-common'
import { FormCard } from '@lmc/ui-kit'
import type React from 'react'
import type { ReactNode } from 'react'
import styled from 'styled-components'
import CarePlanSectionContent from '../../../components/carePlans/CarePlanSectionContent'

interface ICarePlanReviewSection {
  title: string
  innerComponent?: ReactNode
  content?: string
  fields?: CarePlan
  FORM_ID?: string
  richText?: boolean
  onChangeHtml?: (html?: string) => void
}

export const CarePlanReviewSection = ({
  fields,
  title,
  content,
  FORM_ID,
  innerComponent = undefined,
  richText,
  onChangeHtml
}: ICarePlanReviewSection): React.ReactElement => {
  const Card = title === 'Strengths' ? StyledFormCard : FormCard

  return (
    <Card title={title}>
      {innerComponent}
      <CarePlanSectionContent
        formId={FORM_ID}
        fields={fields}
        keys={title.toLowerCase()}
        value={content}
        formFieldLabel={title === 'Strengths' ? 'Notes' : undefined}
        richText={richText}
        onChangeHtml={onChangeHtml}
      />
    </Card>
  )
}

const StyledFormCard = styled(FormCard)`
  .ant-divider {
    margin: 16px 0 !important;
  }
`

export default CarePlanReviewSection
